import { FC } from 'react';
import { $Formutil, connect } from 'react-bootstrap-formutil';
import SwitchFormutil from 'components/Formutil/SwitchFormutil';
import type { FormCheckType } from 'types/common';
import type { CustomerInfoKeyType } from 'types/customer';
import classlist from 'utils/classlist';

export interface TradeTypeFormutil {
    opt_perm: FormCheckType;
    treasury_perm: FormCheckType;
}

interface TradeTypeProps {
    $formutil: $Formutil<TradeTypeFormutil>;
    age: number;
    disabled?: boolean;
    className?: string;
    hideOption?: boolean; // 隐藏期权
    hideTreasury?: boolean; // 隐藏国债
}

export const defaultFieldsOfTradeType: CustomerInfoKeyType[] = ['opt_perm', 'treasury_perm'];

const TradeType: FC<TradeTypeProps> = ({ className, disabled, hideOption, hideTreasury }) => {
    return (
        <div className={classlist('trade-type-root', className)}>
            <h4 className="mt-4 mb-3">{__('Trade Type')}</h4>
            {/* 股票和EFT默认开通，用户不可进行操作 */}
            <SwitchFormutil label={__('Stock')} name="temporary_stk_default" $defaultValue={true} disabled />
            <SwitchFormutil label={__('ETF')} name="temporary_stk_etf" $defaultValue={true} disabled />
            {!hideOption && (
                <SwitchFormutil label={__('Option')} name="opt_perm" checked="1" unchecked="0" disabled={disabled} />
            )}
            {!hideTreasury && (
                <SwitchFormutil
                    label={__('Treasuries')}
                    name="treasury_perm"
                    checked="1"
                    unchecked="0"
                    disabled={disabled}
                />
            )}
        </div>
    );
};

export default connect(TradeType);
